<template>
    <div>
        <question :text="$t(item.text)" />
        <dropdown
            title="Please select..."
            :options="options"
            @select="handleSelect"
        />
    </div>
</template>
<script>
import question from '@/components/ui/question'
import dropdown from '@/components/inputs/dropdown'

export default {
    name: 'dropdownChoiceItem',
    components: {
        question,
        dropdown,
    },
    props: {
        item: {
            type: Object
        }
    },
    computed: {
        options() {
            return this.item.choices.map(choice => ({
                text: this.$t(choice.text),
                value: choice.result
            }))
        }
    },
    methods: {
        handleSelect(result) {
            this.$emit('answer', { choice: result, result: 1 })
        }
    },
}
</script>
<style lang="scss">

</style>
